module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1800.a36995ad.svg";